
































import { defineComponent, type PropType } from "vue-demi";
import GGPromoButton from "./GGPromoButton/GGPromoButton.vue";
import type { Product } from "@constructor/shared-entity/type";
import Swiper from "swiper";
import { Autoplay } from "swiper/modules";
import throttle from "lodash.throttle";

export default defineComponent({
  name: "GGProductSliderCard",
  components: {
    GGPromoButton,
  },
  props: {
    items: {
      type: Array as PropType<Product[]>,
      required: true,
    },
    labelText: {
      type: String as PropType<string>,
      default: undefined,
    },
    promocode: {
      type: String as PropType<string>,
      default: undefined,
    },
    promocodeColor: {
      type: String as PropType<string>,
      default: "black",
      validator(el) {
        return ["transparent-white", "transparent-black", "black"].some(
          (item) => item === el
        );
      },
    },
  },
  data(): {
    slider: null | Swiper;
    throttledResize: (() => void) | null;
  } {
    return {
      slider: null,
      throttledResize: null,
    };
  },
  mounted() {
    this.slider = new Swiper(this.$refs.slider as HTMLElement, {
      slideClass: "constructor-swiper-slide",
      wrapperClass: "constructor-swiper-wrapper",
      slideActiveClass: "constructor-swiper-slide-active",
      slideVisibleClass: "constructor-swiper-slide-visible",
      slideBlankClass: "constructor-swiper-slide-active",
      slideFullyVisibleClass: "constructor-swiper-slide-fully-visible",
      slideNextClass: "constructor-swiper-slide-next",
      slidePrevClass: "constructor-swiper-slide-next",
      modules: [Autoplay],
      allowTouchMove: false,
      slidesPerView: "auto",
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      },
      speed: 400,
      loop: true,
    });

    this.throttledResize = throttle(() => this.slider?.autoplay.resume(), 300);
    window.addEventListener("resize", this.throttledResize);
  },
  destroyed() {
    this.slider = null;
    if (this.throttledResize) {
      window.removeEventListener("resize", this.throttledResize);
    }
  },
});
